/* global axios */
import ApiClient from './ApiClient';

class AccountScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('scheduled_messages', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  getCount({ status = 'pending', conversationId } = {}) {
    return axios.get(`${this.url}/count`, {
      params: {
        status,
        ...(conversationId ? { conversation_id: conversationId } : {}),
      },
    });
  }
}

export default new AccountScheduledMessagesAPI();
